import React from 'react';
import { PropTypes } from 'prop-types';

import { Button } from '@ontruck/orc';

import Modal from 'components/layout/Modal';

const PaymentDataModal = ({
  className,
  img,
  title,
  info,
  handleClose,
  closeLabel,
  handleSubmit,
  submitLabel,
  closeStyle,
}) => (
  <Modal closeButton={false} show size="S" fullHeight>
    <div className={className} data-testid="payment-data-modal">
      <img src={img} alt={title} />
      <div className="info-block">
        <h1 className="title">{title}</h1>
        <span className="label">{info}</span>

        {handleSubmit && submitLabel && (
          <Button onClick={handleSubmit} text={submitLabel} fullWidth />
        )}

        <div className={`${closeStyle || ''}`}>
          <Button
            onClick={handleClose}
            text={closeLabel}
            fullWidth
            skin={closeStyle}
          />
        </div>
      </div>
    </div>
  </Modal>
);

PaymentDataModal.propTypes = {
  className: '',
  img: PropTypes.string,
  title: PropTypes.string,
  info: PropTypes.string,
  handleClose: PropTypes.func,
  closeLabel: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitLabel: PropTypes.string,
  closeStyle: PropTypes.string,
};

PaymentDataModal.defaultProps = {
  className: '',
  img: '',
  title: '',
  info: '',
  handleClose: () => ({}),
  closeLabel: '',
  handleSubmit: () => ({}),
  submitLabel: '',
  closeStyle: 'primary',
};

export default PaymentDataModal;
